import react from 'react';
import { DataResponse, DataState } from '../interfaces/commonInterfaces';
import { message } from "antd"
import { Fonts, apiURL } from "../utils/constants";

 export function GetLeasingCotizacion(dataCotizador: DataState, residual: number | "No element", dataResponse: DataResponse) : any {
        return new Promise((resolve, reject) => {
            fetch(apiURL +`/CotizacionCA`,
            {
                method: "POST",
                body: JSON.stringify({
                        "Anticipo": dataCotizador.assetDownPayment, // Enganche seleccionado en el slider
                        "price": dataCotizador.assetPrice,
                        "Residual": residual,
                        "Plazo": dataResponse.LeasingObjPlazo.filter(r => r.id === dataCotizador.userPlazo)[0].name,
                        "ResidualNominal": residual,
                        "BrandCatalogId": 0,
                        "IVA": 1,
                        "IVARentas": 1,
                        "PorcentajeComision": 2,
                      
                }),
                headers: {
                    'Content-Type': 'application/json'
                  },
            })
            .then(response => response.json())
            .then(response => resolve(response))
            .catch(error => {
                reject(error)
                message.error({ content: 'Error al realizar el cálculo', style: { fontFamily: Fonts.sspRegular } });
            })
        })
}
